// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/engine-cooling.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/engine-cooling/engine-cooling.js';
import g1 from '../lessons/aeronautics/engine-cooling/idle-cooling.js';
import g2 from '../lessons/aeronautics/engine-cooling/throttle-movement.js';

mount([g0, g1, g2]);
